var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticClass:"container"},[_c('iframe',{staticClass:"responsive-iframe",attrs:{"src":_vm.urlReport}})])}
var staticRenderFns = []

export { render, staticRenderFns }